<template>
  <v-layout wrap row>
    <v-flex xs12 my-2 mt-4 style="text-transform:uppercase;font-weight:bold;">
      vendor prices
    </v-flex>
    <v-flex xs12>
      <v-layout wrap row>
        <v-flex xs12 pb-1 v-for="(price, p) in prices" :key="'price-' + p ">
          <v-layout wrap row>
            <v-flex xs6 md2 px-1>
              <v-text-field
                label="Name"
                outline
                @keypress="noSpace($event)"
                hide-details
                v-model="price.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md2 px-1>
              <v-text-field
                label="Value"
                outline
                @keypress="isNumber($event)"
                hide-details
                v-model="price.value"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md2 px-1>
              <v-autocomplete
                :items="resource.countries"
                outline
                item-text="name"
                item-value="id"
                hide-details
                v-model="price.country"
                label="Country"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6 md1 px-1 class="text-xs-center">
              <v-switch label="Active" v-model="price.active" hide-details></v-switch>
            </v-flex>
            <v-flex xs6 md1 px-1 class="text-xs-center">
              <v-switch label="New" v-model="price.new_product" hide-details></v-switch>
            </v-flex>
            <v-flex xs6 md2 px-1 class="text-xs-center">
              <v-switch label="Best Sellers" v-model="price.best_seller" hide-details></v-switch>
            </v-flex>
            <v-flex xs6 md2 px-1 class="text-xs-center">
              <v-switch label="Special Offer" v-model="price.special_offer" hide-details></v-switch>
            </v-flex>
            <v-flex xs6 md2 px-1 class="text-xs-center">
              <v-switch label="Sub Vendor" v-model="price.sub_vendor" hide-details></v-switch>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-btn color="primary" block @click="prices.push({})">add vendor price</v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';

export default {
  components: {
    VueEditor
  },
  props:['loading', 'resource', 'prices'],
  data(){
    return {
      rules: {
        required: value => !!value || 'required',
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'valid_email'
      },
      datePickerFrom:{},
      datePickerTo:{},
      timepicker:{},
      menu:{},
    }
  },
  methods: {
    getNameID(){
      return randomString(24, '#Aa') + `${new Date().getTime()}`
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${x.name} required`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `Not valid email`, 'error')
        }
      })
      return v
    },
    noSpace(evt){
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode == 32 || charCode == 19 || charCode == 9) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    deleteResource(newResource) {
      this.$emit('deleteResource', newResource)
    },
    updateResource(newResource) {
      this.$emit('updateResource', newResource)
    },
    postResource(newResource) {
      this.$emit('postResource', newResource)
    },
    setRTL() {
      this.$refs.editorV[0].quill.format('direction', 'rtl');
      this.$refs.editorV[0].quill.format('align', 'right');
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
  },
  mounted(){
    
  }
}
</script>

<style>

</style>